"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.0678 2.26783C13.9829 2.18292 13.8821 2.11556 13.7712 2.06961C13.6602 2.02365 13.5413 2 13.4213 2C13.3012 2 13.1823 2.02365 13.0714 2.06961C12.9604 2.11556 12.8596 2.18292 12.7747 2.26783L10.9143 4.12839H15.9283L14.0678 2.26783Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.7178 3.03203L9.95349 2.26783C9.78203 2.09637 9.54949 2.00005 9.30701 2.00005C9.06453 2.00005 8.83198 2.09637 8.66052 2.26783L6.8 4.12839H9.62147L10.7178 3.03203Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.3598 5.28201C17.5072 5.351 17.6376 5.45161 17.7418 5.5767C17.8462 5.70152 17.9219 5.84782 17.9634 6.00519C18.0049 6.16256 18.0112 6.32715 17.9819 6.48724L16.7706 13.1534C16.7242 13.4094 16.5893 13.641 16.3895 13.8078C16.1897 13.9746 15.9377 14.0659 15.6775 14.0658H6.66062C6.40051 14.0658 6.14862 13.9746 5.94888 13.808C5.74914 13.6414 5.61421 13.4099 5.56763 13.154L4.24016 5.87422C4.23309 5.8472 4.22806 5.81968 4.2251 5.7919L3.80921 3.51102H2.55551C2.40818 3.51102 2.26688 3.4525 2.16271 3.34832C2.05853 3.24414 2 3.10284 2 2.95551C2 2.80818 2.05853 2.66688 2.16271 2.56271C2.26688 2.45853 2.40818 2.4 2.55551 2.4H3.80914C4.06926 2.39992 4.32116 2.49114 4.52091 2.65776C4.72067 2.82437 4.8556 3.05581 4.9022 3.31173L5.24248 5.17756H16.8888C17.0515 5.17737 17.2123 5.21303 17.3598 5.28201Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.99961 17.3988C7.61321 17.3988 8.11063 16.9014 8.11063 16.2878C8.11063 15.6742 7.61321 15.1768 6.99961 15.1768C6.38601 15.1768 5.88858 15.6742 5.88858 16.2878C5.88858 16.9014 6.38601 17.3988 6.99961 17.3988Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.3323 17.3988C15.9459 17.3988 16.4433 16.9014 16.4433 16.2878C16.4433 15.6742 15.9459 15.1768 15.3323 15.1768C14.7187 15.1768 14.2213 15.6742 14.2213 16.2878C14.2213 16.9014 14.7187 17.3988 15.3323 17.3988Z",
    fill: fill
  }));
};

exports["default"] = _default;